<div *ngIf="!showComprobante" class="d-flex justify-content-between mt-4">
  <ng-container *ngIf="currentStep === 1; else otherSteps">
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="handleConvencidoClick()"
    >
      Aún no estoy convencido
    </button>
    <button
      type="button"
      class="btn btn-primary px-4"
      (click)="handleNextClick()"
    >
      Siguiente paso
    </button>
  </ng-container>
  <ng-template #otherSteps>
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="previous.emit()"
    >
      Volver
    </button>
    <button
      type="button"
      class="btn btn-primary px-4"
      [disabled]="isStep6Disabled"
      (click)="handleNextClick()"
    >
      {{ getNextButtonText() }}
    </button>
  </ng-template>
</div>
